exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.discount-result[data-v-1d7c13d2] {\n    background: #eee;\n    padding: 10px 15px;\n    margin: -16px;\n    font-weight: 500;\n    font-size: 16px;\n}\n.message-error[data-v-1d7c13d2] {\n    color: #e5322c;\n}\nh3[data-v-1d7c13d2] {\n    font-size: 18px;\n}\nstrong[data-v-1d7c13d2] {\n    font-weight: 500;\n}\n", ""]);

// exports
